import { Component, OnInit } from '@angular/core';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {ServerPageRequest} from '../../../classes/common/table/server-page-request';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {CallsQuotaApiService} from '../../../services/api/settings/routing/calls-quota/calls-quota-api.service';
import {AcDialogService} from 'ac-infra';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {MatDialog} from '@angular/material/dialog';
import {PageEvent} from '@angular/material/paginator';
import {CallsQuotaDialogComponent} from './calls-quota-dialog/calls-quota-dialog.component';
import _ from 'lodash';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {TrueFalsePipe} from '../../../pipes/true-false/true-false.pipe';
import {PeriodicityPipe} from './periodicity.pipe';

@Component({
  selector: 'calls-quota',
  templateUrl: './calls-quota.component.html',
  styleUrls: ['./calls-quota.component.scss']
})
export class CallsQuotaComponent implements OnInit {

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'name', display: 'Name', selected: true,  width: 150},
    {name: 'quota', display: 'Quota', selected: true, width: 100},
    {name: 'periodicity', display: 'Periodicity', selected: true, width: 100, transformer: PeriodicityPipe},
    {name: 'blockCalls', display: 'Block Calls', selected: true, width: 100, transformer: TrueFalsePipe}
  ];

  data = {elements: [], totalElements: 0} ;
  isUnauthorized: any;
  selection: any;

  serverPageRequest: ServerPageRequest = new ServerPageRequest({
    pageIndex: 0,
    pageSize: 25,
    length: 0
  });

  constructor(private userPrivilege: UserPrivilegeService,
              private callsQuotaApiService: CallsQuotaApiService,
              private acDialogService: AcDialogService,
              private loaderService: LoaderService,
              private snackBarService: SnackBarService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.refresh();
  }

  public refresh(): void {
    this.callsQuotaApiService.getCallsQuotas({... this.serverPageRequest}).subscribe(data => {
      this.data = data;
    });
  }

  addCallsQuota(): void {
    const dialogData = {name: '', periodicity: 'DAILY'};
    this.acDialogService.open(CallsQuotaDialogComponent, {
      dialogData,
      title: 'Add Calls Quota',
      onSubmit: () => {
        this.callsQuotaApiService.addCallsQuota(dialogData).subscribe(() => {
          this.refresh();
          this.snackBarService.display(`"${dialogData.name}" successfully added`);
        });
      }
    });
  }

  deleteCallsQuota(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete the calls quota: "${this.selection.name}" ?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.callsQuotaApiService.deleteCallsQuota(this.selection.id).subscribe(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.selection.name} successfully deleted`);
      }, () => {
      });
    });
  }

  updateCallsQuota(): void {
    const dialogData = _.cloneDeep(this.selection);
    this.acDialogService.open(CallsQuotaDialogComponent, {
      dialogData,
      title: 'Edit Calls Quota',
      onSubmit: () => {

        if (dialogData.periodicity !== this.selection.periodicity){
          const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: {
              message: `Changing the frequency will reset the calls duration count on a Peer Connection or Resource Group using this quota`
            }
          });

          dialogRef.componentInstance.onApply.subscribe(() => {
            this.callsQuotaApiService.editCallsQuota(dialogData, dialogData.id).subscribe(() => {
              this.refresh();
              this.snackBarService.display(`"${dialogData.name}" successfully updated`);
              dialogRef.close();
            });
          });
        }else{
          this.callsQuotaApiService.editCallsQuota(dialogData, dialogData.id).subscribe(() => {
            this.refresh();
            this.snackBarService.display(`"${dialogData.name}" successfully updated`);
          });
        }
      }
    });
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  pageChanged(pageInfo: PageEvent): void {
    this.serverPageRequest = new ServerPageRequest(pageInfo);

    this.refresh();
  }
}
